import React, { Component } from 'react';
import * as Sentry from '@sentry/react';
import ErrorRefreshPage from './ErrorRefreshPage';

class ErrorHandler extends Component {
  constructor(props) {
    super(props);
    this.state = { eventId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    if (this.state.hasError) {
      // render fallback UI
      return <ErrorRefreshPage />;
    }

    // when there's no error, render children untouched
    return this.props.children;
  }
}

export default ErrorHandler;
